// extracted by mini-css-extract-plugin
module.exports = {"root":"VIP_App__root"};